/*
 * Fork of:
 *
 * https://github.com/backstage/backstage/blob/master/plugins/scaffolder-react/src/next/components/ReviewState/util.ts
 *
 * Changes:
 *
 * - All magic thrown away from `formatKey` to not damage and distort template question texts
 */

import { ParsedTemplateSchema } from '@backstage/plugin-scaffolder-react/alpha'
import { JsonObject, JsonValue } from '@backstage/types'
import { Draft07 as JSONSchema } from 'json-schema-library'

export function isJsonObject(value?: JsonValue): value is JsonObject {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

// Helper function to format a key into a human-readable string
export function formatKey(key: string): string {
  return key
}

export function findSchemaForKey(
  key: string,
  schemas: ParsedTemplateSchema[],
  formState: Partial<{ [key: string]: JsonValue }>
): ParsedTemplateSchema | null {
  for (const step of schemas) {
    /*
      To determine if a key is defined in a schema we need to call getSchema
      with an empty form state. Otherwise, it will never return undefined as it
      will fallback to a default schema based on the form state. 

      An exception to this is when your schema is dynamic i.e. using dependencies 
      because the form state is required for generating the schema. In this case,
      we add only the dependencies data to the getSchema call.
    */

    const schema = step.mergedSchema

    // Declare data to be a subset of formState
    const data: typeof formState = {}

    if (schema.dependencies && isJsonObject(schema.dependencies)) {
      for (const dep in schema.dependencies) {
        if (formState.hasOwnProperty(dep)) {
          data[dep] = formState[dep] // Add each dependency key from formState
        }
      }
    }

    const draft = new JSONSchema(schema)
    const res = draft.getSchema({
      pointer: `#/${key}`,
      data
    })

    if (!!res) {
      return step
    }
  }

  return null // Return null if the key isn't found in any schema
}
